import React from 'react'
import img2041 from '../components/images/ietsy.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2041} alt='etsy' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Etsy Listing Services
                    </h2>
                    <p>Enhance your Etsy shop’s success with our comprehensive listing services, tailored to boost visibility and drive sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b>Create and optimize listings with detailed descriptions, quality images, and relevant keywords for increased visibility and appeal. </li>
                <li><b>•	Advertising Campaign:</b>Execute targeted ad campaigns to elevate product visibility and attract more customers. </li>
                <li><b>•	Promotion:</b> Boost sales with effective promotional strategies, including discounts and special offers. </li>
                <li><b>•	Category Approval:</b> Ensure your products are categorized accurately to comply with Etsy’s guidelines and enhance discoverability. </li>
                <li><b>•	Account Health:</b> Maintain a healthy seller account, adhering to Etsy’s policies and performance standards. </li>
                <li><b>•	Order Processing:</b> Streamline order management from receipt to delivery, ensuring timely and efficient customer service. </li>
                <li><b>•	Payment Reconciliation:</b> Manage payments accurately, ensuring transactions are documented and discrepancies resolved promptly. </li>
                <li><b>•	Keyword Optimization:</b> Enhance search rankings and visibility with strategic keyword use for product listings. </li>
                <li><b>•	Safety Compliance:</b>Ensure your products meet safety standards and handle compliance efficiently. </li>
                <li><b>•	Basic Training:</b>Provide essential training to effectively manage your Etsy shop and utilize platform features. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to increase sales through optimized listings and targeted promotions.</li>
            </ul>
        </>
    )
}

export default events